import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import * as toastr from 'toastr';
import {RegionModel} from '../../../models/RegionModel';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import {ProviderModel} from '../../../models/ProviderModel';
import {DesignServicesModel} from '../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../models/CurrencyModel';
import {Router} from '@angular/router';
import {ContractualDataModel} from '../../../models/ContractualDataModel';
import {LoaderService} from '../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-contract-type-anagraf',
  templateUrl: './contract-type-anagraf.component.html',
  styleUrls: ['./contract-type-anagraf.component.scss']
})
export class ContractTypeAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy, OnChanges {

  filter: ContractTypeModel;
  filterAllSettings: AllSettingsFilterModel;
  contractFilter: ContractualDataModel;

  displayedColumns: Array<string>;
  dataSource: any;
  isAnagraphSection: boolean;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  pageSize: number;
  initAfterOnChange: boolean;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Input() showActions?: boolean;
  @Input() inAllSettings?: boolean;
  @Input() inAllContractMonth?: boolean;
  @Input() idSelected?: number;
  @Input() multipleSelection?: boolean;
  @Input() regionForFilterInSettings?: RegionModel;
  @Input() providerForFilterInSettings?: ProviderModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;

  @Input() localCustomerListForFilterInSettings?: Array<LocalCustomerModel>;
  @Input() regionListForFilterInSettings?: Array<RegionModel>;
  @Input() providerListForFilterInSettings?: Array<ProviderModel>;

  @Input() contractTypeSelectedList?: Array<ContractTypeModel>;

  @Input() numAnnoMeseFromForFilterInSettings?: number;
  @Input() numAnnoMeseToForFilterInSettings?: number;

  @Output() elementSelected = new EventEmitter();



  constructor(private contractTypeService: ContractTypeService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.isAnagraphSection = ProjectConstants.returnIsAnagraphSection(this.router.url);
    this.showActions = true;
    this.multipleSelection = false;
    this.filter = new ContractTypeModel();
    this.offset = new Offset();
    this.initAfterOnChange = false;
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('regionForFilterInSettings' in changes
      || 'localCustomerForFilterInSettings' in changes
      || 'resourceUnitForFilterInSettings' in changes
      || 'designServicesForFilterInSettings' in changes
      || 'currencyForFilterInSettings' in changes
      || 'providerForFilterInSettings' in changes
      || 'regionListForFilterInSettings' in changes
      || 'localCustomerListForFilterInSettings' in changes
      || 'providerListForFilterInSettings' in changes) {
      this.initAfterOnChange = true;
      this.getAll(this.offset);
    }
  }

  ngOnInit() {
    if (this.showActions) {
      this.displayedColumns = ['contractTypeCod', 'contractTypeDesc', 'startNumAnnoMese',
                              'endNumAnnoMese', 'inContractTypeSetting', 'actions'];
    } else {
      if (this.multipleSelection) {
        this.displayedColumns = ['isSelected', 'contractTypeCod', 'contractTypeDesc', 'startNumAnnoMese', 'endNumAnnoMese'];
      } else {
        this.displayedColumns = ['contractTypeCod', 'contractTypeDesc', 'startNumAnnoMese', 'endNumAnnoMese'];
      }
    }

    this.pageSize = +this.PAGINATOR.PAGE_SIZE_ARRAY[0];

    this.setOffsetInSession();
    if (!this.initAfterOnChange) {
      this.getAll(this.offset);
    }
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    if (this.inAllSettings) {
      this.filterAllSettings = new AllSettingsFilterModel();

      this.filterAllSettings.region = this.regionForFilterInSettings;
      this.filterAllSettings.resourceUnit = this.resourceUnitForFilterInSettings;
      this.filterAllSettings.localCustomer = this.localCustomerForFilterInSettings;
      this.filterAllSettings.provider = this.providerForFilterInSettings;
      this.filterAllSettings.contractType = this.filter;

      this.filterAllSettings.localCustomerList = this.localCustomerListForFilterInSettings;
      this.filterAllSettings.regionList = this.regionListForFilterInSettings;
      this.filterAllSettings.providerList = this.providerListForFilterInSettings;

      this.getPageSubscribe = this.contractTypeService.getPageInAllSettings(offset, this.filterAllSettings)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.setChecked();
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else if (this.inAllContractMonth) {
      this.contractFilter = new ContractualDataModel();
      this.contractFilter.numAnnoMeseFrom = this.numAnnoMeseFromForFilterInSettings;
      this.contractFilter.numAnnoMeseTo = this.numAnnoMeseToForFilterInSettings;
      this.contractFilter.region = this.regionForFilterInSettings;
      this.contractFilter.resourceUnit = this.resourceUnitForFilterInSettings;
      this.contractFilter.localCustomer = this.localCustomerForFilterInSettings;
      this.contractFilter.contractType = this.filter;
      this.contractFilter.provider = this.providerForFilterInSettings;

      this.getPageSubscribe = this.contractTypeService.getPageInAllContractMonth(offset, this.contractFilter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else {
      this.getPageSubscribe = this.contractTypeService.getPage(offset, this.filter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    }
  }

  filterTable() {
    this.getAll(new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0));
  }

  resetTable() {
    this.filter = new ContractTypeModel();
    this.getAll(new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0));
  }
  openDialog(id: number) {
    const regionData = this.dataSource.find(data => data.id === id) as ContractTypeModel;
    const list: GenericArray[] = [
      { id: 'Contract Type Cod', value: regionData.cod.toString() },
      { id: 'Contract Type Description', value: regionData.description.toString() }
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.contractTypeService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Contract Type with id ' + id + ' was deleted with success', 'Success');
              this.getAll(this.offset);
            } else {
              toastr.info('Contract Type cannot be deleted', 'Alert');
            }

          }, error => {
            this.loaderService.display(false);
            toastr.error('Contract Type with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.dataSource = dataFiltered.content;
    this.listData = new MatTableDataSource(this.dataSource);
    this.paginator.pageIndex = this.offset.pageIndex;
    this.paginator.length = dataFiltered.totalElements;

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  selectRow(row: any) {
    if (!this.multipleSelection) {
      this.elementSelected.emit({ row });
    }
  }

  selectMultipleRow(row: any) {
    this.elementSelected.emit({ row });
  }

  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('contractTypeOffset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('contractTypeOffset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      this.pageSize = this.offset.pageSize;
    }
  }


  setChecked() {
    if (this.contractTypeSelectedList && this.contractTypeSelectedList.length > 0) {
      for (let _i = 0; _i < this.dataSource.length; _i++) {
        const contractType: ContractTypeModel = this.dataSource[_i];
        for (let _j = 0; _j < this.contractTypeSelectedList.length; _j++) {
          if (contractType.id ===  this.contractTypeSelectedList[_j].id) {
            contractType.checked = true;
          }
        }
      }
    }
  }

  getAnnoMese(annoMese: number ): string {
    const year = Number(annoMese.toString().substring(0, 4));
    const month = Number(annoMese.toString().substring(4, 6));

    const options = { month: 'long', year: 'numeric' };
    const parsedYearMonth = new Date(year, month - 1);

    return parsedYearMonth.toLocaleDateString('en-US', options);
  }
}
